var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3917 7.00016C17.5312 7.22249 18.5785 7.7798 19.3995 8.60075C20.2204 9.42171 20.7777 10.469 21.0001 11.6085M16.3917 2.3335C18.7592 2.5965 20.9669 3.6567 22.6523 5.34C24.3378 7.02331 25.4007 9.22967 25.6667 11.5968M21.5833 24.5002C11.5962 24.5002 3.5 16.404 3.5 6.41683C3.5 5.96624 3.51648 5.5195 3.54887 5.07718C3.58604 4.56955 3.60463 4.31574 3.73765 4.0847C3.84783 3.89335 4.04309 3.71186 4.24198 3.61596C4.48211 3.50016 4.76219 3.50016 5.32235 3.50016H8.6092C9.08026 3.50016 9.31578 3.50016 9.51769 3.57769C9.69604 3.64617 9.85485 3.7574 9.98015 3.90161C10.122 4.06487 10.2025 4.28622 10.3635 4.72891L11.724 8.47022C11.9113 8.98528 12.0049 9.24281 11.989 9.48714C11.975 9.70259 11.9015 9.90993 11.7766 10.0861C11.635 10.2858 11.4 10.4268 10.9301 10.7088L9.33333 11.6668C10.7355 14.7572 13.2418 17.2667 16.3333 18.6668L17.2914 17.0701C17.5733 16.6001 17.7143 16.3652 17.9141 16.2236C18.0902 16.0987 18.2976 16.0252 18.513 16.0112C18.7574 15.9953 19.0149 16.0889 19.5299 16.2762L23.2713 17.6367C23.7139 17.7977 23.9353 17.8781 24.0986 18.02C24.2428 18.1453 24.354 18.3041 24.4225 18.4825C24.5 18.6844 24.5 18.9199 24.5 19.391V22.6778C24.5 23.238 24.5 23.518 24.3842 23.7582C24.2883 23.9571 24.1068 24.1523 23.9155 24.2625C23.6844 24.3955 23.4306 24.4141 22.923 24.4513C22.4807 24.4837 22.0339 24.5002 21.5833 24.5002Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneCall);
export default __webpack_public_path__ + "static/media/phone-call.3d43e0f029d07101e6a53a28d4e9d729.svg";
export { ForwardRef as ReactComponent };